import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

const LoginForm = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Check if already logged in on component mount
  useEffect(() => {
    if (api.isAuthenticated()) {
      // Verify the stored token still works
      const verifyToken = async () => {
        setLoading(true);
        try {
          // Try to fetch workouts to verify token is still valid
          await api.getWorkouts();
          if (onLoginSuccess) onLoginSuccess();
        } catch (error) {
          // If token is invalid, clear it
          api.logout();
        } finally {
          setLoading(false);
        }
      };
      
      verifyToken();
    }
  }, [onLoginSuccess]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password) {
      setError('Please enter the password');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const success = await api.login(password);
      
      if (success) {
        // Call onLoginSuccess callback directly instead of relying on page reload
        if (onLoginSuccess) onLoginSuccess();
      } else {
        setError('Invalid password');
      }
    } catch (error) {
      setError('Login failed. Please try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-form-container">
      <div className="login-form">
        <h2>Login</h2>
        <p>Enter the password to access your workout data</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            className="login-button"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;